import React from 'react';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { EventsEventTextWrapper, TooltipBackground } from './styledComponent';

export default function BottomTooltip({ props }) {
  const { assetBackground = assetSource(ASSET_KEY.BOTTOM_BAR_TOOLTIP), displayText, style, titleStyle } = props;

  return (
    <div className="Events-tooltip AnimationFadeIn" style={style}>
      <TooltipBackground src={assetBackground} />
      <EventsEventTextWrapper style={titleStyle}>{displayText}</EventsEventTextWrapper>
    </div>
  );
}

